import React, { useState, useEffect } from "react";
import { useLocalization } from "../../localization/LocalizationContext";
import allApi from "../../../../api/allApi";
import { isNetworkName, isVlanId } from "../../common/configValidation";
import { useNetwork } from "../../common/networkContext";

function ConfigNet({
  data,
  setData,
  setIsValid,
  apiCall1,
  vlanData,
  setVlanData,
}) {
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId } = useNetwork();
  const defaultNetworkId = selectedNetworkId?.id ?? 6001;
  // const [networkName, setNetworkName] = useState(data.networkName || "");
  // const [description, setDescription] = useState(data.description || "");
  // const [networkType, setNetworkType] = useState(data.networkType || "");
  // const [vlanName, setVlanName] = useState(data.vlanName || "");
  // const [vlanId, setVlanId] = useState(data.vlanId || "");

  const [networkNameError, setNetworkNameError] = useState("");
  const [vlanNameError, setVlanNameError] = useState("");
  const [vlanIdError, setVlanIdError] = useState("");
  const [networkId, setNetworkId] = useState();
  const [networkIds, setNetworkIds] = useState([]);

  const validateNetworkName = (value) => {
    if (!isNetworkName(value)) {
      setNetworkNameError(
        "Network name must be 1-255 letters, numbers, spaces, hyphens, or underscores."
      );
    } else {
      setNetworkNameError("");
    }
  };

  const validateVlanName = (value) => {
    const trimmed = String(value || "").trim();
    if (trimmed.length === 0 || trimmed.length > 32) {
      setVlanNameError("VLAN Name must be between 1 and 32 characters.");
    } else {
      setVlanNameError("");
    }
  };

  const validateVlanId = (value) => {
    if (!isVlanId(value) || Number(value) > 4093) {
      setVlanIdError("VLAN ID must be a number between 1 and 4093.");
    } else {
      setVlanIdError("");
    }
  };

  const isFormValid = () => {
    return (
      vlanData.vlanNwName &&
      !networkNameError &&
      vlanData.name &&
      !vlanNameError &&
      vlanData.vlanId &&
      !vlanIdError &&
      vlanData.qosConfig &&
      vlanData.networkId
    );
  };

  useEffect(() => {
    fetchNetworkIds();
  }, []);

  useEffect(() => {
    setIsValid(isFormValid());
  }, [vlanData, networkNameError, vlanNameError, vlanIdError]);

  const handleSubmit = async () => {
    if (isFormValid()) {
      try {
        await apiCall1({
          networkName: vlanData.vlanNwName,
          description: vlanData.vlanNwDesc,
          networkType: vlanData.qosConfig,
          networkId: vlanData.networkId,
          vlanName: vlanData.name,
          vlanId: vlanData.vlanId,
        });

        alert("Network configuration submitted successfully.");
      } catch (error) {
        console.error("Submission failed", error);
        alert("An error occurred while submitting the form.");
      }
    }
  };

  const fetchNetworkIds = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/network/getAssociatedNetwork");
      if (
        response &&
        response.status === "OK" &&
        Array.isArray(response.response)
      ) {
        const ids = response.response.map((network) => ({
          network_id: network.network_id,
          network_name: network.network_name,
        }));
        setNetworkIds(ids);
        if (!vlanData.networkId) {
          const fallback = ids.some((n) => String(n.network_id) === String(defaultNetworkId))
            ? defaultNetworkId
            : ids[0]?.network_id;
          if (fallback) {
            setVlanData((prev) => ({ ...prev, networkId: fallback }));
            setData((prev) => ({ ...prev, networkId: fallback }));
          }
        }
      }
    } catch (error) {
      console.error("Error fetching network IDs:", error);
    }
  };

  const handleNetworkChange = (e) => {
    const selectedValue = e.target.value;
    setNetworkId(selectedValue);
    setVlanData((prev) => ({
      ...prev,
      networkId: selectedValue,
    }));
    setData((prev) => ({
      ...prev,
      networkId: selectedValue,
    }));
  };

  return (
    <div>
      <h4>{localizationStrings?.configureNetwork}</h4>
      <p>{localizationStrings?.networkDetails}</p>
      <div className="row mb-3">
        <div className="col-lg-4">
          <label className="form-label">
            {localizationStrings?.vlanName}{" "}
            <span>(1-32 {localizationStrings?.characters})</span>
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${vlanNameError ? "is-invalid" : ""}`}
            value={vlanData.name || ""}
            onChange={(e) => {
              const value = e.target.value;
              setVlanData((prev) => ({ ...prev, name: value }));
              validateVlanName(value);
            }}
          />
          {vlanNameError && <p style={{ color: "red" }}>{vlanNameError}</p>}
        </div>
        <div className="col-lg-4">
          <label className="form-label">
            {localizationStrings?.vlanId}{" "}
            <span>(1-4093, {localizationStrings?.uniqueNumber})</span>
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${vlanIdError ? "is-invalid" : ""}`}
            value={vlanData.vlanId || ""}
            onChange={(e) => {
              const value = e.target.value;
              setVlanData((prev) => ({ ...prev, vlanId: value }));
              validateVlanId(value);
            }}
          />
          {vlanIdError && <p style={{ color: "red" }}>{vlanIdError}</p>}
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-4">
          <label className="form-label">
            {localizationStrings?.networkName}{" "}
            <span>(1-255 {localizationStrings?.characters})</span>
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${networkNameError ? "is-invalid" : ""}`}
            value={vlanData.vlanNwName || ""}
            onChange={(e) => {
              const value = e.target.value;
              setVlanData((prev) => ({ ...prev, vlanNwName: value }));
              validateNetworkName(value);
            }}
          />
          {networkNameError && (
            <p style={{ color: "red" }}>{networkNameError}</p>
          )}
        </div>
        <div className="col-lg-4">
          <label className="form-label">
            {localizationStrings?.description}
          </label>
          <input
            type="text"
            className="form-control"
            value={vlanData.vlanNwDesc || ""}
            onChange={(e) =>
              setVlanData((prev) => ({ ...prev, vlanNwDesc: e.target.value }))
            }
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-4">
          <label className="form-label">
            {localizationStrings?.networkType}
            <span className="text-danger">*</span>
          </label>
          <select
            className="form-select"
            value={vlanData.qosConfig || ""}
            onChange={(e) => {
              const value = e.target.value;
              setVlanData((prev) => ({ ...prev, qosConfig: value }));
            }}
          >
            <option value="">{localizationStrings?.selectNetworkType}</option>
            <option value="dataNetwork">
              {localizationStrings?.dataNetwork}
            </option>
            <option value="voiceVlan">{localizationStrings?.voiceVlan}</option>
            <option value="videoVlan">{localizationStrings?.VideoVlan}</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label className="form-label">
            {localizationStrings?.networkId}
            <span className="text-danger">*</span>
          </label>
          <select
            id="networkId"
            className="form-select"
            name="networkId"
            value={vlanData.networkId || ""}
            onChange={handleNetworkChange}
          >
            <option value="">{localizationStrings?.selectNetwork}</option>
            {networkIds.map((net) => (
              <option key={net.network_id} value={net.network_id}>
                {net.network_name || net.network_id}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default ConfigNet;
